export const downloadBlobFile = (
  blob: Blob | null,
  fallbackFileName: string,
  response?: Response,
  contentTypePrefix = "filename",
): void => {
  if (!blob) {
    console.error("Cannot download the file", fallbackFileName, " because the blob is:", blob);
    return;
  }

  const resolvedFileName = resolveDownloadFilename(blob, fallbackFileName, response, contentTypePrefix);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = resolvedFileName;

  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

const resolveDownloadFilename = (
  blob: Blob,
  fallbackFileName: string,
  response?: Response,
  contentTypePrefix = "filename",
): string => {
  const filenameFromHeaders = getFilenameFromHeaders(response, "Content-Disposition");
  if (filenameFromHeaders) {
    return filenameFromHeaders;
  }

  const contentType = response?.headers.get("content-type") || blob.type;
  if (contentType.includes("zip")) {
    return `${contentTypePrefix}.zip`;
  }

  if (contentType.includes("jpeg")) {
    return `${contentTypePrefix}.jpeg`;
  }

  if (contentType.includes("png")) {
    return `${contentTypePrefix}.png`;
  }

  return fallbackFileName;
};

const getFilenameFromHeaders = (response: Response | undefined, headerName: string): string | null => {
  if (!response) {
    return null;
  }

  const header = response.headers.get(headerName);
  if (!header) {
    return null;
  }

  const trimQuotes = (value: string): string => value.trim().replace(/^"|"$/g, "");

  const encodedFilenameMatch = header.match(/(?:^|;)\s*filename\*\s*=\s*([^;]+)/i);

  if (encodedFilenameMatch?.[1]) {
    const encodedValue = trimQuotes(encodedFilenameMatch[1]);
    const utf8Prefix = "UTF-8''";

    const normalizedValue = encodedValue.toUpperCase().startsWith(utf8Prefix)
      ? encodedValue.slice(utf8Prefix.length)
      : encodedValue;

    return decodeURIComponent(normalizedValue);
  }

  const filenameMatch = header.match(/(?:^|;)\s*filename\s*=\s*("[^"]+"|[^;]+)/i);

  if (filenameMatch?.[1]) {
    return trimQuotes(filenameMatch[1]);
  }

  return null;
};
